import React, { useState } from "react";
import { BaseModal, IModalInstance, ModalHeader } from "@whatslly/ui-components/modals";
import styles from "./PurchacePhoneModal.module.scss";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";
import { ModalButtons } from "@whatslly/ui-components/ModalButtons";
import { TextInput } from "@whatslly/ui-components/v2/BaseElements/TextInput";

interface RenamePhoneModalProps extends IModalInstance<{ name: string }> {
  name: string;
}

export const RenamePhoneModal: React.FC<RenamePhoneModalProps> = observer(({ closeModal, ...props }) => {
  const { t } = useTranslation();
  const [name, setName] = useState(props.name);

  return (
    <BaseModal
      header={<ModalHeader closeModal={closeModal}>{t("twilio_settings_page.actions_phone_table.rename_phone")}</ModalHeader>}
      closeModal={closeModal}
      className={styles.renameModal}
      closeOnClickOutside={false}
      closeOnEscape={false}
    >
      <TextInput placeholder={t("twilio_settings_page.cols.name")} paddingInline="none" value={name} onChange={(e) => setName(e.target.value)} />
      <ModalButtons
        isSubmitDisabled={name === props.name || !name}
        testId="modal-buttons-submit-button"
        onCancel={closeModal}
        onSubmit={() => closeModal({ name })}
      />
    </BaseModal>
  );
});
